import React from "react"
import {ItemTimelineDetail} from "../../../services/order/eventHelper"
import {ItemKeyEvents} from "../../../dtos/eventResponse"
import {Box, Chip, Tooltip} from "@mui/material"
import {Timeline, TimelineConnector, TimelineDot, TimelineItem, TimelineSeparator} from "@mui/lab"
import {makeStyles} from "tss-react/mui"

interface ItemTimelineProps {
	itemStatus: string
	itemDeliveryDate: string
	keyEvents: ItemKeyEvents | undefined
	itemTimeLineDetails: ItemTimelineDetail[]
}

const useStyles = makeStyles()({
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "16px",
	},
	chipContainer: {
		display: "flex",
		padding: "3px 4px",
		alignItems: "center",
	},
	chip: {
		height: "24px",
		marginTop: "10px",
		background: "var(--action-selected, rgba(0, 0, 0, 0.08))",
		color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		borderRadius: "100px",
		".MuiChip-label": {
			paddingLeft: "6px",
			paddingRight: "6px",
			fontFeatureSettings: "'liga' off, 'clig' off",
			fontSize: "13px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "18px",
			letterSpacing: "0.16px",
		},
	},
	redChip: {
		height: "24px",
		marginTop: "10px",
		background: "#db1002",
		color: "white",
		borderRadius: "100px",
		".MuiChip-label": {
			paddingLeft: "6px",
			paddingRight: "6px",
			fontFeatureSettings: "'liga' off, 'clig' off",
			fontSize: "13px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "18px",
			letterSpacing: "0.16px",
		},
	},
	timelineDotHighlighted: {
		background: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		marginTop: "5px",
		marginBottom: "5px",
	},
	timelineDot: {
		strokeWidth: "2px",
		stroke: "var(--action-disabled, rgba(0, 0, 0, 0.38))",
		marginTop: "5px",
		marginBottom: "5px",
	},
	timelineConnectorHighlighted: {
		width: "12px",
		height: "2px",
		transform: "rotate(270deg)",
		background: "var(--text-primary, rgba(0, 0, 0, 0.87))",
	},
	timelineConnector: {
		width: "12px",
		height: "2px",
		transform: "rotate(270deg)",
		background: "var(--action-disabled, rgba(0, 0, 0, 0.38))",
	},
	timeline: {
		padding: 0,
		display: "flex",
		flexDirection: "row",
		marginTop: "0px",
	},
	timelineItem: {
		minHeight: "auto",
		"&:before": {
			padding: "6px 6px",
		},
	},
	timeLineSeparator: {
		display: "flex",
		alignItems: "center",
		transform: "rotate(270deg)",
		flex: 1,
	},
})

export default function ItemTimeline(props: ItemTimelineProps) {
	const {classes} = useStyles()
	const getChipLabel = () => {
		let label = props.itemStatus
		if (props.itemStatus === "Delivered" && props.itemDeliveryDate !== "") {
			label = `${label}: ${new Date(props.itemDeliveryDate).toDateString()}`
		}
		return label
	}

	const getTimelineDotTooltip = (timeLineItem: ItemTimelineDetail) => {
		let toolTipLabel = timeLineItem.status
		if (timeLineItem.date !== "") {
			toolTipLabel = `${timeLineItem.status}: ${new Date(timeLineItem.date).toString()}`
		}
		return toolTipLabel
	}

	return (
		<Box className={classes.container}>
			<div className={classes.chipContainer}>
				<Chip
					label={getChipLabel()}
					className={
						["Cancelled", "Rejected"].includes(props.itemStatus) ? classes.redChip : classes.chip
					}
				/>
			</div>
			<Timeline className={classes.timeline}>
				{props.itemTimeLineDetails.map((timeLineItem) => {
					return (
						<TimelineItem className={classes.timelineItem}>
							<TimelineSeparator className={classes.timeLineSeparator}>
								<Tooltip title={getTimelineDotTooltip(timeLineItem)} disableHoverListener={false}>
									<TimelineDot
										variant={timeLineItem.highlighted ? "filled" : "outlined"}
										className={
											timeLineItem.highlighted
												? classes.timelineDotHighlighted
												: classes.timelineDot
										}
									/>
								</Tooltip>

								{props.itemTimeLineDetails.indexOf(timeLineItem) <
									props.itemTimeLineDetails.length - 1 && (
									<TimelineConnector
										className={
											timeLineItem.highlighted
												? classes.timelineConnectorHighlighted
												: classes.timelineConnector
										}
									/>
								)}
							</TimelineSeparator>
						</TimelineItem>
					)
				})}
			</Timeline>
		</Box>
	)
}
